export * from './providers.service';
import { ProvidersScrapingService } from './providers.service';
export * from './providers.serviceInterface'
export * from './sessions.service';
import { SessionsScrapingService } from './sessions.service';
export * from './sessions.serviceInterface'
export const APIS = [ProvidersScrapingService, SessionsScrapingService];
